import React from 'react';
import styled from "styled-components"

const LineDivider = styled.div`
    height: 1px;
    border-bottom : 0.5px solid #dedede;
    margin: 10px -10px;
`

export default () => {
    return (
        <LineDivider />
    );
};